import { useAppSelector } from '@/app/hooks';
import { SelectAuth } from '@/features/spotifyAuth/authSlice';
import { IListMusic } from '@/interface';
import { Header } from '../../molecules/Header';
import { Spinner } from '../../atoms/Spinner';
import './listMusic.scss';
import { PlayListCard } from '@/components/molecules/PlayListCard';
import { logout } from '@/utils/logout';
import { useAuthStore } from '@/zustand/useAuthGoogle';

export const ListMusic = ({ playlists, status }: IListMusic) => {
  const { user: userSpotify, isGuest } = useAppSelector(SelectAuth);
  const userGoogle = useAuthStore((state) => state.user);

  return (
    <main className='m-listMusic'>
      <Header
        avatar={
          userSpotify.images
            ? userSpotify.images[0]?.url
            : userGoogle?.photoURL ?? ''
        }
        name={userSpotify.display_name}
      />
      <div className='m-listMusic__card'>
        {status === 'loading' && <Spinner />}
        {status === 'failed' && !isGuest && (
          <h2 onClick={logout} className='m-listMusic__message'>
            return to log
          </h2>
        )}
        {status === 'ok' && (
          <PlayListCard playlists={playlists} isGuest={isGuest} />
        )}
      </div>
    </main>
  );
};
